export default __webpack_public_path__ + "static/media/verified.5bedaed5.svg";